import { render, staticRenderFns } from "./ProntuarioVacina.vue?vue&type=template&id=223ba6a4&"
import script from "./ProntuarioVacina.vue?vue&type=script&lang=js&"
export * from "./ProntuarioVacina.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioVacina.vue?vue&type=style&index=0&id=223ba6a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports